import { Box, styled, css } from '@creditas-ui/react'

const isOpen = ({ isOpen }) => isOpen && css`
  opacity: 1;
  max-height: 730px;

  @media screen and (min-width: 980px) {
    max-height: 500px;
  }
`

const AccordionItemLogic = styled(Box)`
  width: 100%;
  opacity: 0;
  max-height: 0;
  transition: max-height 600ms ease, opacity 600ms ease;
  ${isOpen}
`

export { AccordionItemLogic }
